import { SiteFooter, SiteHeader } from './SiteChrome';

export const NotFound = () => {
  return (
    <div className="ff-page">
      <SiteHeader />
      <div className="ff-content" style={{ textAlign: 'center', paddingTop: 64 }}>
        <p className="ff-kicker">Foul ball</p>
        <h1>We couldn&apos;t find that page</h1>
        <p>
          The page you&apos;re looking for doesn&apos;t exist or has moved. If you followed
          a link that should work, let us know at{' '}
          <a href="mailto:support@fieldfactsbaseball.com">support@fieldfactsbaseball.com</a>.
        </p>
        <a className="ff-button ff-button-primary" href="/" style={{ marginTop: 12 }}>
          Back to home plate
        </a>
      </div>
      <SiteFooter />
    </div>
  );
}
